import React from "react";
import {FormattedMessage} from "react-intl";
import Empty from "./Empty";

import classes from "./styles.module.css";

function EventsWidget() {
    const openSupportWidget = (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('open-support-widget'));
    };

    return (
        <div className={classes.Card}>
            <div className={classes.Header}>
                <h5>
                    <FormattedMessage id="EventsWidget.title" defaultMessage="События"/>
                </h5>
                <a className={classes.Button} href="#" onClick={openSupportWidget}>
                    <FormattedMessage id="EventsWidget.btn.createTicket" defaultMessage="Оставить обращение"/>
                </a>
            </div>

            <div className={classes.Content}>
                <Empty/>
            </div>
        </div>
    );
}

export default EventsWidget;



// WEBPACK FOOTER //
// ./src/Components/EventsWidget/index.js